/* ============================================================
   Custom Announcement Bar — custom-announcement-bar.js
   Infinite-loop slider: appends a clone of the first slide after
   the last, animates up to it, then snaps back to slide 0 with
   transitions disabled so the loop reads as seamless.
   ============================================================ */
(function () {
  function initSlider(slider) {
    var wrap = slider.querySelector('.cab__slides-wrap');
    var slides = slider.querySelectorAll('.cab__slide');
    if (!wrap || slides.length <= 1) return;

    var total = slides.length;
    var clone = slides[0].cloneNode(true);
    clone.classList.add('cab__slide--clone');
    wrap.appendChild(clone);
    slider.style.setProperty('--cab-slide-count', total + 1);

    var slideCount = total + 1;
    var autoPlay = slider.getAttribute('data-auto-play') === 'true';
    var speedSec = parseInt(slider.getAttribute('data-speed'), 10) || 5;
    var currentIndex = 0;

    function showSlide(index) {
      currentIndex = index;
      var offset = (currentIndex / slideCount) * 100;
      wrap.style.transform = 'translateX(-' + offset + '%)';
    }

    function resetToFirst() {
      wrap.style.transition = 'none';
      wrap.style.transform = 'translateX(0)';
      currentIndex = 0;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          wrap.style.transition = '';
        });
      });
    }

    function nextSlide() {
      if (currentIndex === total - 1) {
        showSlide(total);
        wrap.addEventListener('transitionend', function onEnd() {
          wrap.removeEventListener('transitionend', onEnd);
          resetToFirst();
        }, { once: true });
      }
      else {
        showSlide(currentIndex + 1);
      }
    }

    function prevSlide() {
      if (currentIndex === 0) {
        wrap.style.transition = 'none';
        var offset = (total / slideCount) * 100;
        wrap.style.transform = 'translateX(-' + offset + '%)';
        currentIndex = total;
        requestAnimationFrame(function () {
          requestAnimationFrame(function () {
            wrap.style.transition = '';
            showSlide(total - 1);
          });
        });
      }
      else {
        showSlide(currentIndex - 1);
      }
    }

    showSlide(0);

    if (autoPlay) {
      setInterval(nextSlide, speedSec * 1000);
    }
    else {
      var track = slider.closest('.cab__track');
      if (track) {
        var prevBtn = track.querySelector('.cab__arrow--prev');
        var nextBtn = track.querySelector('.cab__arrow--next');
        if (prevBtn) prevBtn.addEventListener('click', prevSlide);
        if (nextBtn) nextBtn.addEventListener('click', nextSlide);
      }
    }
  }

  function init() {
    var sliders = document.querySelectorAll('.cab__slider');
    for (var i = 0; i < sliders.length; i++) {
      initSlider(sliders[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  }
  else {
    init();
  }
})();
